const infoContent = document.querySelector(".main-info-content");

if (typeof infoContent != "undefined" && infoContent != null) {
	const infoContentText = infoContent.textContent;
	const summaryContent = document.querySelector(".main-page-summary-content");
	if (typeof summaryContent != "undefined" && summaryContent != null) {
		const summaryParaElement = document.createElement("p");
		const truncatedSummary = infoContentText.substring(0, 300);
		summaryParaElement.textContent = truncatedSummary;
		summaryContent.appendChild(summaryParaElement);
	}
}

//Go To Section

const sectionHeadings = document.querySelectorAll(".section-heading h2");
const summarySidebar = document.querySelector(".sidebar-page-summary-content");

if (typeof summarySidebar != "undefined" && summarySidebar != null) {
	const goToNav = document.createElement("nav");
	const goToList = document.createElement("ol");
	goToNav.setAttribute("aria-label", "Table of Contents");
	goToNav.classList.add("content-nav");
	goToList.setAttribute("id", "table-contents");
	goToList.setAttribute("role", "menu");
	goToList.setAttribute("aria-labelledby", "contents-toggle");

	if (typeof sectionHeadings != "undefined" && sectionHeadings != null) {
		const goToListHeading = document.createElement("h3");
		const goToListHeadingButton = document.createElement("button");
		goToListHeadingButton.setAttribute("type", "button");
		goToListHeadingButton.setAttribute("id", "contents-toggle");
		goToListHeadingButton.setAttribute("aria-haspopup", "true");
		goToListHeadingButton.setAttribute("aria-controls", "table-contents");
		goToListHeadingButton.textContent = "Go To Section";

		goToListHeading.appendChild(goToListHeadingButton);
		goToNav.appendChild(goToListHeading);

		for (var i = 0; i < sectionHeadings.length; ++i) {
			const sectionHeading = sectionHeadings[i];
			let goToListItem = document.createElement("li");
			let goToListItemSpan = document.createElement("span");

			goToListItem.setAttribute("role", "menuitem");
			// goToListItemSpan.setAttribute('role' , 'menuitem');

			goToListItemSpan.textContent = sectionHeading.textContent;
			goToListItem.appendChild(goToListItemSpan);
			goToList.appendChild(goToListItem);
			goToListItem.addEventListener("click", (event) => {
				sectionHeading.scrollIntoView({
					behavior: "auto",
				});
			});
			goToListItem.addEventListener("keydown", (event) => {
				if (event.key === "Enter") {
					sectionHeading.scrollIntoView({
						behavior: "auto",
					});
				}
			});
		}
	}

	goToNav.appendChild(goToList);
	summarySidebar.appendChild(goToNav);
}

class MenuButtonLinks {
	constructor(domNode) {
		this.domNode = domNode;
		this.buttonNode = domNode.querySelector("button");
		this.menuNode = domNode.querySelector('[role="menu"]');
		this.menuitemNodes = [];
		this.firstMenuitem = false;
		this.lastMenuitem = false;
		this.firstChars = [];

		this.buttonNode.addEventListener(
			"keydown",
			this.onButtonKeydown.bind(this)
		);
		this.buttonNode.addEventListener("click", this.onButtonClick.bind(this));

		var nodes = domNode.querySelectorAll('[role="menuitem"]');

		for (var i = 0; i < nodes.length; i++) {
			var menuitem = nodes[i];
			this.menuitemNodes.push(menuitem);
			menuitem.tabIndex = -1;
			this.firstChars.push(menuitem.textContent.trim()[0].toLowerCase());

			menuitem.addEventListener(
				"click",
				function () {
					domNode.classList.remove("is-open");
					domNode.querySelector("button").classList.remove("is-open");
					domNode.querySelector('[role="menu"]').classList.remove("is-open");
					domNode.querySelector("button").removeAttribute("aria-expanded");
				},
				false
			);

			menuitem.addEventListener("keydown", this.onMenuitemKeydown.bind(this));

			menuitem.addEventListener(
				"mouseover",
				this.onMenuitemMouseover.bind(this)
			);

			if (!this.firstMenuitem) {
				this.firstMenuitem = menuitem;
			}
			this.lastMenuitem = menuitem;
		}

		domNode.addEventListener("focusin", this.onFocusin.bind(this));
		domNode.addEventListener("focusout", this.onFocusout.bind(this));

		window.addEventListener(
			"mousedown",
			this.onBackgroundMousedown.bind(this),
			true
		);
	}

	setFocusToMenuitem(newMenuitem) {
		this.menuitemNodes.forEach(function (item) {
			if (item === newMenuitem) {
				item.tabIndex = 0;
				newMenuitem.focus();
			} else {
				item.tabIndex = -1;
			}
		});
	}

	setFocusToFirstMenuitem() {
		this.setFocusToMenuitem(this.firstMenuitem);
	}

	setFocusToLastMenuitem() {
		this.setFocusToMenuitem(this.lastMenuitem);
	}

	setFocusToPreviousMenuitem(currentMenuitem) {
		var newMenuitem, index;

		if (currentMenuitem === this.firstMenuitem) {
			newMenuitem = this.lastMenuitem;
		} else {
			index = this.menuitemNodes.indexOf(currentMenuitem);
			newMenuitem = this.menuitemNodes[index - 1];
		}

		this.setFocusToMenuitem(newMenuitem);

		return newMenuitem;
	}

	setFocusToNextMenuitem(currentMenuitem) {
		var newMenuitem, index;

		if (currentMenuitem === this.lastMenuitem) {
			newMenuitem = this.firstMenuitem;
		} else {
			index = this.menuitemNodes.indexOf(currentMenuitem);
			newMenuitem = this.menuitemNodes[index + 1];
		}
		this.setFocusToMenuitem(newMenuitem);

		return newMenuitem;
	}

	setFocusByFirstCharacter(currentMenuitem, char) {
		var start, index;

		if (char.length > 1) {
			return;
		}

		char = char.toLowerCase();

		// Get start index for search based on position of currentItem
		start = this.menuitemNodes.indexOf(currentMenuitem) + 1;
		if (start >= this.menuitemNodes.length) {
			start = 0;
		}

		// Check remaining slots in the menu
		index = this.firstChars.indexOf(char, start);

		// If not found in remaining slots, check from beginning
		if (index === -1) {
			index = this.firstChars.indexOf(char, 0);
		}

		// If match was found...
		if (index > -1) {
			this.setFocusToMenuitem(this.menuitemNodes[index]);
		}
	}

	// Utilities

	getIndexFirstChars(startIndex, char) {
		for (var i = startIndex; i < this.firstChars.length; i++) {
			if (char === this.firstChars[i]) {
				return i;
			}
		}
		return -1;
	}

	// Popup menu methods

	openPopup() {
		this.menuNode.classList.add("is-open");
		this.buttonNode.setAttribute("aria-expanded", "true");
	}

	closePopup() {
		if (this.isOpen()) {
			this.buttonNode.removeAttribute("aria-expanded");
			this.menuNode.classList.remove("is-open");
		}
	}

	isOpen() {
		return this.buttonNode.getAttribute("aria-expanded") === "true";
	}

	// Menu event handlers

	onFocusin() {
		this.domNode.classList.add("focus");
	}

	onFocusout() {
		this.domNode.classList.remove("focus");
	}

	onButtonKeydown(event) {
		var key = event.key,
			flag = false;

		switch (key) {
			case " ":
			case "Enter":
			case "ArrowDown":
			case "Down":
				this.openPopup();
				this.setFocusToFirstMenuitem();
				flag = true;
				break;

			case "Esc":
			case "Escape":
				this.closePopup();
				this.buttonNode.focus();
				flag = true;
				break;

			case "Up":
			case "ArrowUp":
				this.openPopup();
				this.setFocusToLastMenuitem();
				flag = true;
				break;

			default:
				break;
		}

		if (flag) {
			event.stopPropagation();
			event.preventDefault();
		}
	}

	onButtonClick(event) {
		if (this.isOpen()) {
			this.closePopup();
			this.buttonNode.focus();
		} else {
			this.openPopup();
			this.setFocusToFirstMenuitem();
		}

		event.stopPropagation();
		event.preventDefault();
	}

	onMenuitemKeydown(event) {
		var tgt = event.currentTarget,
			key = event.key,
			flag = false;

		function isPrintableCharacter(str) {
			return str.length === 1 && str.match(/\S/);
		}

		if (event.ctrlKey || event.altKey || event.metaKey) {
			return;
		}

		if (event.shiftKey) {
			if (isPrintableCharacter(key)) {
				this.setFocusByFirstCharacter(tgt, key);
				flag = true;
			}

			if (event.key === "Tab") {
				this.buttonNode.focus();
				this.closePopup();
				flag = true;
			}
		} else {
			switch (key) {
				case " ":
					window.location.href = tgt.href;
					break;

				case "Esc":
				case "Escape":
					this.closePopup();
					this.buttonNode.focus();
					flag = true;
					break;

				case "Up":
				case "ArrowUp":
					this.setFocusToPreviousMenuitem(tgt);
					flag = true;
					break;

				case "ArrowDown":
				case "Down":
					this.setFocusToNextMenuitem(tgt);
					flag = true;
					break;

				case "Home":
				case "PageUp":
					this.setFocusToFirstMenuitem();
					flag = true;
					break;

				case "End":
				case "PageDown":
					this.setFocusToLastMenuitem();
					flag = true;
					break;

				case "Tab":
					this.closePopup();
					break;

				case "Enter":
					this.closePopup();
					break;

				default:
					if (isPrintableCharacter(key)) {
						this.setFocusByFirstCharacter(tgt, key);
						flag = true;
					}
					break;
			}
		}

		if (flag) {
			event.stopPropagation();
			event.preventDefault();
		}
	}

	onMenuitemMouseover(event) {
		var tgt = event.currentTarget;
		tgt.focus();
	}

	onBackgroundMousedown(event) {
		if (!this.domNode.contains(event.target)) {
			if (this.isOpen()) {
				this.closePopup();
				this.buttonNode.focus();
			}
		}
	}
}

// Initialize menu buttons
document.arrive(".content-nav", { existing: true }, function () {
	let menuButtons = document.querySelectorAll(".content-nav");
	for (let i = 0; i < menuButtons.length; i++) {
		new MenuButtonLinks(menuButtons[i]);
	}
});

const summaryContentSection = document.querySelector(".page-summary-content");

const numSteps = 20.0;
let prevRatio = 0.0;
let oldScrollValue = 0;
let newScrollValue = 0;

window.addEventListener(
	"load",
	(event) => {
		if (
			typeof summaryContentSection != "undefined" &&
			summaryContentSection != null
		) {
			createObserver(summaryContentSection);
		}
	},
	false
);

function createObserver(element) {
	let observer;

	let options = {
		root: null,
		rootMargin: "0px",
		threshold: buildThresholdList(),
	};

	observer = new IntersectionObserver(handleIntersect, options);
	observer.observe(element);
}

function buildThresholdList() {
	let thresholds = [];
	let numSteps = 20;

	for (let i = 1.0; i <= numSteps; i++) {
		let ratio = i / numSteps;
		thresholds.push(ratio);
	}

	thresholds.push(0);
	return thresholds;
}

function handleIntersect(entries, observer) {
	entries.forEach((entry) => {
		if (entry.intersectionRatio > 0.01) {
			if (typeof summaryContentSection != "undefined" && summaryContentSection != null) {
				summaryContentSection.classList.remove("outOfView");
				summaryContentSection.classList.remove("animate-in");
			}
		} else if (entry.intersectionRatio < 0.01) {
			if (typeof summaryContentSection != "undefined" && summaryContentSection != null) {
				summaryContentSection.classList.add("outOfView");
				setTimeout(() => {
					summaryContentSection.classList.add("animate-in");
				}, 300);
			}
		}
	});
}

window.addEventListener("scroll", (e) => {
	newScrollValue = window.pageYOffset;
	const infoSidebar = document.querySelector(".sidebar-cta-card");
	if (oldScrollValue < newScrollValue) {
		if (typeof summaryContentSection != "undefined" && summaryContentSection != null) {
			summaryContentSection.classList.add("going-down");
			summaryContentSection.classList.remove("going-up");
		}
		if (typeof infoSidebar != "undefined" && infoSidebar != null) {
			infoSidebar.style.top = "";
		}
	} else if (oldScrollValue > newScrollValue) {
		if (typeof infoSidebar != "undefined" && infoSidebar != null) {
			infoSidebar.style.top = "7rem";
		}
		if (typeof summaryContentSection != "undefined" &&summaryContentSection != null) {
			summaryContentSection.classList.add("going-up");
			summaryContentSection.classList.remove("going-down");
		}
	}
	oldScrollValue = newScrollValue;
});
